import axios from 'axios';
import { storeAction } from '../storeActions.constant';
import { storeGetters } from '../storeGetters.constant';
import { storeMutation } from '../storeMutations.constant';
import { getBasicHeaders } from '../../common/utils/utils';
import { wrapAction } from '../../common/utils/actionLifecycle';

const policiesProceduresState = {
    baseURL: process.env.VUE_APP_BASE_URL,
    policiesHeadings: null,
    articleData: [],
    articleId: null,
    searchPoliciesAndProcedures: [],
};

const policiesProceduresMutations = {
    [storeMutation.setPoliciesHeadings]: (state, data) => {
        state.policiesHeadings = data;
    },
    [storeMutation.setArticleData]: (state, data) => {
        const articleTemp = {};
        articleTemp.Id = state.articleId;
        articleTemp.data = data;
        state.articleData.push(articleTemp);
    },
    [storeMutation.setArticleId]: (state, data) => {
        state.articleId = data;
    },
};

const policiesProceduresActions = {
    [storeAction.getPoliciesHeadings]: ({ state, commit }) => {
        return axios({
            url: `${state.baseURL}profiles/api/tools/policies/get-headings`,
            //url: `mocks/policiesHeadings.json`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setPoliciesHeadings, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.getArticleData]: wrapAction(storeAction.getArticleData, ({ state, commit }, articleId) => {
        return axios({
            url: `${state.baseURL}profiles/api/tools/policies/get-article-data/${articleId}`,
            //url: `mocks/policiesSections.json`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setArticleId, articleId);
                commit(storeMutation.setArticleData, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),

    [storeAction.getPoliciesAndProceduresSearch]: wrapAction(storeAction.getPoliciesAndProceduresSearch, ({ state }, searchToken) => {
        return axios({
            url: `${state.baseURL}profiles/api/tools/policies/search/${searchToken}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
};

const policiesProceduresGetters = {
    [storeGetters.policiesHeadings]: state => state.policiesHeadings,
    [storeGetters.articleData]: state => state.articleData,
    [storeGetters.searchPoliciesAndProcedures]: state => state.searchPoliciesAndProcedures,
};

export default {
    namespaced: true,
    state: {
        initialState: policiesProceduresState,
        ...policiesProceduresState,
    },
    mutations: { ...policiesProceduresMutations },
    actions: { ...policiesProceduresActions },
    getters: { ...policiesProceduresGetters },
};
